export default __webpack_public_path__ + "static/media/Dickmon.95bfa487.PNG";